// ============================================
// ROLC OneROLC - Auth Service
// Version: 3.6.0
// ============================================

import { CONFIG, IDLE_TIMEOUT_MS, IDLE_KEY } from '../config/constants.js';
import {
    getToken, setToken, removeToken,
    getSessionId, setSessionId, removeSessionId,
    getName, setName, removeName,
    getRole, setRole, removeRole,
    getIsMasterAdmin, setIsMasterAdmin, removeIsMasterAdmin,
    setLastActivity,
    clearAuth
} from '../utils/storage.js';
import { apiCall } from '../api/apiClient.js';

// ============================================
// Login / Confirm
// ============================================
export async function login(fullName, lastName, pin) {
    const data = await apiCall('confirm', { fullName, lastName, pin });
    const result = data.result || data;

    if (result.error) {
        return { success: false, error: result.error };
    }

    setToken(result.token);
    setSessionId(result.sessionId);
    setName(result.fullName);
    setRole(result.role || 'member');
    setLastActivity();

    return {
        success: true,
        token: result.token,
        sessionId: result.sessionId,
        fullName: result.fullName,
        role: result.role || 'member',
        isFirstTime: result.isFirstTime || false
    };
}

// ============================================
// Quick Login (PIN only)
// ============================================
export async function quickLogin(pin) {
    const token = getToken();
    if (!token) {
        return { success: false, error: 'No token found. Please log in with your name.' };
    }

    const data = await apiCall('quickLogin', { token, pin });

    if (data.error) {
        return { success: false, error: data.error };
    }

    if (data.sessionId) setSessionId(data.sessionId);
    if (data.role) setRole(data.role);
    setLastActivity();

    return {
        success: true,
        name: data.name,
        role: data.role,
        token: data.token,
        sessionId: data.sessionId
    };
}

// ============================================
// Forgot PIN
// ============================================
export async function forgotPin(fullName, lastName) {
    const data = await apiCall('forgotPin', { fullName, lastName });
    return data;
}

// ============================================
// Check PIN Status
// ============================================
export async function checkPinStatus(fullName, lastName) {
    const data = await apiCall('checkPinStatus', { fullName, lastName });
    return data.result || data;
}

// ============================================
// Search Members
// ============================================
export async function searchMembers(query) {
    const data = await apiCall('searchMembers', { query });
    return data;
}

// ============================================
// Logout
// ============================================
export function logout(redirectToLogin = true) {
    clearAuth();
    if (redirectToLogin) {
        window.location.replace('/login.html');
    }
}

// ============================================
// Session Check
// ============================================
export function isAuthenticated() {
    const token = getToken();
    const name = getName();
    return !!(token && name);
}

export function getCurrentUser() {
    return {
        token: getToken(),
        name: getName(),
        role: getRole(),
        sessionId: getSessionId(),
        isMasterAdmin: getIsMasterAdmin()
    };
}

// ============================================
// Store Role from API Response
// ============================================
export function storeRoleFromData(data) {
    if (data && data.userRole) {
        setRole(data.userRole);
    }
    if (data && typeof data.isMasterAdmin === 'boolean') {
        setIsMasterAdmin(data.isMasterAdmin);
    }
}

// ============================================
// Idle Check
// ============================================
export function checkIdle() {
    const last = localStorage.getItem(IDLE_KEY);
    if (last) {
        const elapsed = Date.now() - parseInt(last, 10);
        if (elapsed > IDLE_TIMEOUT_MS) {
            return true;
        }
    }
    return false;
}


